


import React, { useEffect, useMemo, useState } from 'react';
import { CONFIG } from 'config/config';
import { isMobile } from 'react-device-detect';
import {
	BackendWrapper,
	NavigationWrapper,
	Page,
	SessionWrapper,
	Text,
	UiWrapper,
	View,
} from '@coinscrap/webapp-core';

import { Wrapper } from 'layout/components/Body/Wrapper';
import Header from 'layout/components/Header/Header';

import { MainModal } from 'components/MainModal/MainModal';

import { useGetError } from 'hooks/useGetError';
import { useInitialScrollToTop } from 'hooks/useInitialScrollToTop';

export const Continue = () => {
	const { getInstanceApi } = BackendWrapper.use();
	const { navigateTo } = NavigationWrapper.use();
	const { startSession, clearSession } = SessionWrapper.use();
	const { useHeader, useLoading, openModal } = UiWrapper.use();
	const { query } = Page.use();

	const [loading, setLoading] = useState();
	const [error, setError] = useState();

	useEffect(() => {
		clearSession();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useLoading(loading, { loadingMessage: loading });
	useHeader(<Header />, []);
	useInitialScrollToTop();
	const getError = useGetError();

	const token = useMemo(() => query?.t, [query]);

	useEffect(() => {
		if (token) {
			(async () => {
				let response;
				try {
					response = await getInstanceApi().loginUser(
						{
							uniqueIdentifier: token,
							source: 'CON',
						},
						'unique-identifier',
					);
					await startSession({ token: response.accessToken });

					localStorage.removeItem('B2Flow');

					CONFIG.routing.continue.next(navigateTo);
				} catch (e) {
					setError(e.status || true);
					setLoading(undefined);
					openModal(
						() => (
							<MainModal
								type="error"
								text={getError(e, 'La clave de acceso no es válida')}
							/>
						),
						{
							disableClickAway: true,
							closeButton: false,
							modalClass: isMobile ? 'modal-xl' : 'modal-main',
							key: 'modal-Continue-KO',
						},
					);
				}
			})();
		} else {
			setLoading(undefined);
			openModal(
				() => (
					<MainModal
						type="error"
						text={getError(
							new Error(
								`No se ha recibido el token en la url. Parámetro query 't'. t ${token}`,
							),
							'La clave de acceso no es válida',
						)}
					/>
				),
				{
					disableClickAway: true,
					closeButton: false,
					modalClass: isMobile ? 'modal-xl' : 'modal-main',
					key: 'modal-ContinueNoToken-KO',
				},
			);
		}
		// eslint-disable-next-line
	}, []);

	return (
		<Wrapper title={'Identificación'}>
			<View innerWrapperSt>
				{error && (
					<Text headingPrimarySt>
						{error === 403 ? (
							<>
								<Text headingPrimarySt>
									La clave de acceso ha caducado o ya ha sido utilizada.
								</Text>
								<Text headingSecondarySt leftSt>
									Solicite un nuevo link de acceso.
								</Text>
							</>
						) : (
							<Text headingPrimarySt>Datos de inicio de sesión incorrectos.</Text>
						)}
					</Text>
				)}
				{!error &&
					(token ? (
						<Text headingPrimarySt>
							Estamos obteniendo tus datos de usuario, espere por favor.
						</Text>
					) : (
						<>
							<Text headingPrimarySt>
								No se han encontrado datos de inicio de sesión.
							</Text>
							<Text headingSecondarySt leftSt>
								Asegurese que esta accediendo correctamente a la plataforma.
							</Text>
						</>
					))}
			</View>
		</Wrapper>
	);
};
